'use strict';

import template from './password_form.html';

const controller = function ($scope, $state, $stateParams, password, userModel, systemAlerts, auth) {
  'ngInject';
  var isResettingPassword = false;
  const successfullPasswordChange = 'Password successfully changed';

  function transitionToSettings() {
    $state.go('settings').then(() => {
      systemAlerts.success(successfullPasswordChange);
    });
  }

  this.verifyParams = function () {
    this.isVerifying = true;

    password.verifyPasswordResetParams($stateParams)
      .then(function () {
        isResettingPassword = true;
      })
      .catch(function () {
        $state.go('forgotPassword');
      }.bind(this))
      .finally(function () {
        delete this.isVerifying;
      }.bind(this));
  };

  this.submit = function () {
    this.isLoading = true;

    (isResettingPassword ? password.resetPassword : password.changePassword)(angular.copy(this.data), $stateParams).then(function(r) {
      if (isResettingPassword) {
        auth.manualLogin(r).then(() => {
          transitionToSettings();
        });
      } else {
        transitionToSettings();
      }
    });
  };

  this.checkPassword = function () {
    var password = this.data && this.data.password;
    var passwordRepeated = this.passwordRepeat;

    if (password && passwordRepeated !== password) {
      this.passwordForm && this.passwordForm.passwordRepeat.$setValidity('match', false);
    } else {
      this.passwordForm && this.passwordForm.passwordRepeat.$setValidity('match', true);
    }
  };

  $scope.$watch('ctrl.data.password', this.checkPassword.bind(this));
  $scope.$watch('ctrl.passwordRepeat', this.checkPassword.bind(this));

  if ($stateParams.uid && $stateParams.code && $stateParams.email) {
    this.verifyParams($stateParams);
  } else if (!userModel.item.id) {
    $state.go('forgotPassword');
  } else {
    this.hasPassword = ($stateParams.create !== 'true');
  }
};

const saPasswordForm = [
  function () {
    return {
      template: template,
      replace: true,
      controllerAs: 'ctrl',
      controller: controller
    };
  }
];

export default saPasswordForm;



// WEBPACK FOOTER //
// ./app/src/modules/password_form/password_form.component.js